import React, { useMemo } from 'react';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
export function ZinniaProvider({ children, shouldPrependEmotionStyles = false, insertionPoint, }) {
    const cache = useMemo(() => createCache({
        key: 'css',
        prepend: true,
        insertionPoint,
    }), []);
    return shouldPrependEmotionStyles ? (React.createElement(CacheProvider, { value: cache }, children)) : (children);
}
//# sourceMappingURL=ZinniaProvider.js.map
// @zapier/design-system-context@1.5.0 (2376bbd83)
